import type { IBulkOperationResponseType } from '@/types/api-types/IApiResponse'
import type { TApiResponse, TApiResponseType } from '@/types/api-types/TApiResponse'
import type {
  IWorkOrderApi,
  TDeleteWorkOrderParams,
  TGetWorkOrderByIdParams,
  TGetWorkOrderParams,
  TUpdateWorkOrderByIdParams,
  TUpdateWorkOrderByIdRequestBody
} from '@/types/api-types/work-orders'
import BaseApiRequest from '../BaseApiRequest'
import WorkOrderApiUrl from './endpoints'

class WorkOrderApiRequest extends BaseApiRequest implements IWorkOrderApi {
  async getWorkOrder(params: TGetWorkOrderByIdParams): TApiResponse {
    const { id, ...rest } = params
    const url = `${WorkOrderApiUrl.WORK_ORDER_BY_ID(params.id)}`
    return this.get(url, rest)
  }

  async updateWorkOrder(
    params: TUpdateWorkOrderByIdParams,
    requestBody: TUpdateWorkOrderByIdRequestBody
  ): TApiResponse {
    const { id, ...rest } = params
    const url = `${WorkOrderApiUrl.WORK_ORDER_BY_ID(id)}`
    return this.put(url, requestBody, rest)
  }

  async getWorkOrders(params: TGetWorkOrderParams): TApiResponse {
    console.log(params)
    return this.get(WorkOrderApiUrl.WORK_ORDER(), params)
  }

  async deleteWorkOrders(
    params?: TDeleteWorkOrderParams
  ): TApiResponseType<IBulkOperationResponseType> {
    return this.delete(WorkOrderApiUrl.WORK_ORDER(), params)
  }

  async createWorkOrder(requestBody: TUpdateWorkOrderByIdRequestBody, params?: any): TApiResponse {
    return this.post(WorkOrderApiUrl.WORK_ORDER(), requestBody, params)
  }
}

export default WorkOrderApiRequest
